import React from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { formatDate } from "../utils/dateUtils";

dayjs.extend(utc);

const URGENCY_STYLES = {
  overdue: {
    backgroundColor: "#fff1f0",
    color: "#cf1322",
    borderColor: "#ffccc7",
  },
  soon: {
    backgroundColor: "#fffbe6",
    color: "#d48806",
    borderColor: "#ffe58f",
  },
  ok: {
    backgroundColor: "#f6ffed",
    color: "#389e0d",
    borderColor: "#b7eb8f",
  },
};

export const getDueDateUrgency = (dateString) => {
  if (!dateString) return null;

  const dueDate = dayjs.utc(dateString).startOf("day");
  if (!dueDate.isValid()) return null;

  const daysUntil = dueDate.diff(dayjs.utc().startOf("day"), "day");

  if (daysUntil < 0) return "overdue";
  if (daysUntil <= 3) return "soon";
  return "ok";
};

const DueDatePill = ({ dateString, status }) => {
  const formatted = formatDate(dateString);
  if (!dateString || formatted === "-") {
    return formatted;
  }

  if (status && status !== "Open") {
    return <span className="text-gray-500">{formatted}</span>;
  }

  const urgency = getDueDateUrgency(dateString);
  if (!urgency) {
    return formatted;
  }

  const styles = URGENCY_STYLES[urgency];

  return (
    <span
      className="inline-block rounded border px-2 py-0.5 text-xs font-medium"
      style={styles}
    >
      {formatted}
    </span>
  );
};

export default DueDatePill;
